<script setup lang="ts">
  import { Employee } from '@/classes/Employee'
  import BaseProfilePicture from '../profile-picture/BaseProfilePicture.vue'
  import { EmpSort, useEmployeeStore } from '@/stores/EmployeeStore'

  const props = defineProps<{
    employee: Employee
  }>()

  const { sortBy } = useEmployeeStore()
</script>
<template>
  <div class="flex items-center justify-between py-1">
    <div
      :id="`select-employee-${props.employee.id}`"
      appium="select-employee"
      :appium-employee-name="`select-employee-${props.employee.first_name.toLocaleLowerCase()}`"
      class="w-full flex flex-row justify-between items-center"
    >
      <div class="flex flex-row items-center gap-1.5 py-1 w-full">
        <base-profile-picture
          :employee-id="employee.id"
          class="mr-1 -ml-2 pointer-events-none"
        />
        <p class="truncate">
          <span :class="{ 'font-semibold': sortBy === EmpSort.FIRST_NAME }">
            {{ props.employee.first_name }}
          </span>
          <span>
            {{ ' ' }}
          </span>
          <span :class="{ 'font-semibold': sortBy === EmpSort.LAST_NAME }">
            {{ props.employee.last_name }}
          </span>
        </p>
      </div>
      <font-awesome-icon class="" icon="fa-regular fa-chevron-right" />
    </div>
  </div>
</template>
